import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import api from './modules/api'
import home from './modules/home'

Vue.use(Vuex)



const store = new Vuex.Store({
  modules: {
    api,
    home
  },
  getters
})

export default store
